// extracted by mini-css-extract-plugin
module.exports = {"seccionPrecio":"styles_seccionPrecio__2jC11","precios":"styles_precios__VHI0k","h2":"styles_h2__1uUfN","texto":"styles_texto__3A7Gw","labelPrice":"styles_labelPrice__OijuA"};